import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 p-0" }
const _hoisted_3 = { class: "card border-0 rounded-0 mb-0" }
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "card-head box-shadow bg-white p-3" }
const _hoisted_6 = {
  key: 0,
  class: "fullscreen-header p-3 bg-white border-bottom"
}
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Maps = _resolveComponent("Maps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-lg-flex align-items-center justify-content-between mb-3" }, null, -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["map-wrapper", { 'fullscreen-map': _ctx.isFullscreen }]),
              ref: "mapContainer"
            }, [
              (_ctx.isFullscreen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_8, [
                          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-geo-alt-fill text-success me-2" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.manifest?.navireNom) + " - Port de Lomé ", 1)
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args))),
                        class: "btn btn-danger btn-sm"
                      }, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("i", { class: "bi bi-x-lg me-1" }, null, -1),
                        _createTextVNode(" Fermer plein écran ", -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Maps, {
                "show-lines": _ctx.showLines,
                "zee-bounds": _ctx.zeeBounds,
                "initial-zoom": 13,
                "initial-center": [6.076841, 1.302920],
                "show-z-e-e": _ctx.showZEE,
                "zee-geo-json": _ctx.zeeGeoJson,
                markers: _ctx.markers,
                "zones-scannage": _ctx.zonesScannage,
                "line-color": "#198754",
                style: _normalizeStyle({ height: _ctx.isFullscreen ? '100vh' : '600px' }),
                onZoneChanged: _ctx.onZoneChanged
              }, null, 8, ["show-lines", "zee-bounds", "show-z-e-e", "zee-geo-json", "markers", "zones-scannage", "style", "onZoneChanged"])
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}